import React, { useState, useMemo, useEffect } from "react";
import { connect } from "react-redux";
import Loading from "components/Loading";
import SpyFilter from "../filter";
import { getInfluencers, getInfluencersFilters } from "actions/spyAdvancedActions";
import useCallApi from "hook/useCallApi";
import { ReactTableDataGrid } from "components/Table";
import { heightRow } from "../constant";
import useColumnTableInfluencer from "../hooks/useColumnTableInfluencer";
import { getQueryParams } from "components/Function";

const limit = 20;

const SpyAdvancedInfluencers = ({ getInfluencers, getInfluencersFilters }) => {
    const { filter: initialFilter, page: initialPage } = getQueryParams();
    const [filter, setFilter] = useState(initialFilter);
    const [search, setSearch] = useState(initialFilter.keyword || "");
    const [page, setPage] = useState(initialPage);
    const params = useMemo(() => ({ ...filter, page, per_page: limit }), [filter, page]);
    const { data, loading } = useCallApi(getInfluencers, params);
    const columns = useColumnTableInfluencer(heightRow, filter.dateRange);
    const { data: influencers_filters } = useCallApi(getInfluencersFilters);

    useEffect(() => {
        const params = new URLSearchParams({ ...filter, page });
        window.history.replaceState({}, "", `${window.location.pathname}?${params.toString()}`);
    }, [filter, page]);

    const onTableChanged = ({ page }) => {
        if (page) setPage(page);
    };

    return (
        <div className="card mb-5 mb-xl-10">
            <Loading isLoading={loading} />
            <div className="card-body">
                <div className="row mb-10">
                    <div className="col-md-4 d-flex align-items-center">
                        <h1 className="mb-0">Influencer</h1>
                    </div>
                    <div className="col-md-8 position-relative">
                        <div className="input-group h-100">
                            <input
                                type="text"
                                className="form-control rounded-end rounded-pill"
                                placeholder="Search..."
                                onChange={(e) => setSearch(e.target.value)}
                            />
                            <button
                                className="btn btn-info rounded-start rounded-pill"
                                type="button"
                                onClick={() => {
                                    setFilter((prev) => ({ ...prev, keyword: search }));
                                    setPage(1);
                                }}
                            >
                                <i className="fas fa-search"></i>
                            </button>
                        </div>
                    </div>
                </div>
                <SpyFilter
                    filter={filter}
                    setFilter={(data) => {
                        setFilter(data);
                        setPage(1);
                    }}
                    filterCategory={[
                        {
                            label: "Influencer Category",
                            key: "influencer_categories",
                            data: influencers_filters?.influencer_categories.map((v, i) => {
                                return {
                                    value: v?.id,
                                    label: v?.name,
                                    name_slug: v?.name_slug,
                                    children: v?.children || [],
                                    count: v?.count,
                                };
                            }),
                        },
                        {
                            label: "Product Category",
                            key: "product_categories",
                            data: influencers_filters?.products_filters.map((v, i) => {
                                return {
                                    value: v?.id,
                                    label: v?.name,
                                    name_slug: v?.name_slug,
                                    children: v?.children || [],
                                    count: v?.count,
                                };
                            }),
                        },
                    ]}
                    filterMoreCategory={influencers_filters?.more_filters}
                    filterShows={[
                        { label: "Region", value: "region", defaultValue: "US" },
                        { label: "Followers", value: "followers_count" },
                        { label: "Likes", value: "likes_count" },
                        { label: "ER Rate", value: "engagement_rate" },
                    ]}
                    filterAdvancedShows={[
                        {
                            label: "Videos views",
                            value: [
                                { label: "Avg video views", value: "views_per_video" },
                                { label: "7-day avg video views", value: "views_per_video_7d" },
                                { label: "Avg sales video views", value: "views_per_video_product" },
                                { label: "7-day avg sales video views", value: "views_per_video_product_7d" },
                            ],
                            defaultValue: "views_per_video",
                            type: "group",
                        },
                        {
                            label: "Estimated GMV",
                            value: [
                                { label: "GMV", value: "gmv" },
                                { label: "30-day GMV", value: "gmv_amt_30d" },
                            ],
                            defaultValue: "gmv",
                            type: "group",
                        },
                        { label: "Follow genders", value: "follower_genders" },
                        { label: "Follow ages", value: "follower_ages" },
                        { label: "Gender", value: "gender" },
                        { label: "Language", value: "language" },
                        { label: "Show Case", value: "show_case" },
                        { label: "Shop owner", value: "is_seller" },
                        { label: "Sale product", value: "sales_flag", type: "checkbox" },
                        { label: "Live", value: "is_live", type: "checkbox" },
                        { label: "Email", value: "is_email", type: "checkbox" },
                        { label: "Date Range", value: "dateRange" },
                    ]}
                />
                <div className="mt-10">
                    <ReactTableDataGrid
                        tableName="influencerSpyAdvanced"
                        idProperty="_id"
                        columns={columns}
                        rowData={data?.data || []}
                        pageNumber={page}
                        gridOptions={{
                            rowHeight: heightRow,
                            reactiveCustomComponents: true,
                        }}
                        paginationPageSize={limit}
                        totalSize={data?.meta?.total || 0}
                        emptyText={"No data!"}
                        isSearchText={false}
                        onTableChanged={onTableChanged}
                    />
                </div>
            </div>
        </div>
    );
};

export default connect(null, { getInfluencers, getInfluencersFilters })(SpyAdvancedInfluencers);
